<footer class="footer footer-static footer-light navbar-border">
  <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
    <span class="float-md-left d-block d-md-inline-block">
      © {{ano}} GÉIA. TODOS OS DIREITOS RESERVADOS <a class="text-bold-800 grey darken-2" href="https://geia.com.br"
        target="_blank"> </a>,CNPJ: 60.899.291/0001-23 - RUA VALDEMAR FERREIRA, 463 - SÃO PAULO - SP <i
        class="ft-heart pink"></i></span>
</footer>